// src/data/languages/swahili/categories/sentencesgap.ts

import { RevisionSentenceCollection } from '../../../../types/types';

// Collection de phrases pour la révision en swahili
export const sentencesgap: RevisionSentenceCollection = {
  // Pronoms personnels au présent progressif
  "nina": [
    { original: "Nina kwenda nyumbani", french: "Je suis en train d'aller à la maison", english: "I am going home" },
    { original: "Nina kusoma", french: "Je suis en train d'étudier", english: "I am studying" },
    { original: "Nina kula", french: "Je suis en train de manger", english: "I am eating" }
  ],
  "tuna": [
    { original: "Tuna kusoma", french: "Nous sommes en train d'étudier", english: "We are studying" },
    { original: "Tuna kwenda nyumbani", french: "Nous sommes en train d'aller à la maison", english: "We are going home" },
    { original: "Tuna kufanya kazi", french: "Nous sommes en train de travailler", english: "We are working" }
  ],
  "una": [
    { original: "Una kula", french: "Tu es en train de manger", english: "You are eating" },
    { original: "Una kukaa", french: "Tu es en train de t'asseoir", english: "You are sitting down" },
    { original: "Una kwenda sokoni", french: "Tu es en train d'aller au marché", english: "You are going to the market" }
  ],
  "ana": [
    { original: "Ana kukaa", french: "Il/Elle est en train de s'asseoir", english: "He/She is sitting down" },
    { original: "Ana kusoma", french: "Il/Elle est en train d'étudier", english: "He/She is studying" },
    { original: "Ana kufanya kazi", french: "Il/Elle est en train de travailler", english: "He/She is working" }
  ],
  "mna": [
    { original: "Mna kuzungumza", french: "Vous êtes en train de parler", english: "You (all) are talking" },
    { original: "Mna kukaa", french: "Vous êtes en train de vous asseoir", english: "You (all) are sitting down" },
    { original: "Mna kula", french: "Vous êtes en train de manger", english: "You (all) are eating" }
  ],
  "wana": [
    { original: "Wana kufanya kazi", french: "Ils/Elles sont en train de travailler", english: "They are working" },
    { original: "Wana kukaa", french: "Ils/Elles sont en train de s'asseoir", english: "They are sitting down" },
    { original: "Wana kwenda nyumbani", french: "Ils/Elles sont en train d'aller à la maison", english: "They are going home" }
  ],

  // Pronoms possessifs
  "yangu": [
    { original: "Nyumba yangu ni kubwa", french: "Ma maison est grande", english: "My house is big" },
    { original: "Elimu yangu ni muhimu", french: "Mon éducation est importante", english: "My education is important" },
    { original: "Mtoto wangu ni mzuri", french: "Mon enfant est en bonne santé", english: "My child is doing well" }
  ],
  "yako": [
    { original: "Shamba lako ni mbichi", french: "Ton champ est humide", english: "Your field is fresh/damp" },
    { original: "Mke wako ni mzuri", french: "Ta femme est belle", english: "Your wife is beautiful" },
    { original: "Nyumba yako ni safi", french: "Ta maison est propre", english: "Your house is clean" }
  ],
  "yake": [
    { original: "Rafiki yake yu mjini", french: "Son ami est en ville", english: "His/Her friend is in town" },
    { original: "Mtoto wake ni mdogo", french: "Son enfant est petit", english: "His/Her child is small" },
    { original: "Baba yake ni mzee", french: "Son père est vieux", english: "His/Her father is old" }
  ],
  "yetu": [
    { original: "Bahati yetu ni kubwa", french: "Notre chance est grande", english: "Our luck is great" },
    { original: "Mtoto wetu anasoma", french: "Notre enfant étudie", english: "Our child is studying" },
    { original: "Nyumba yetu ni kubwa", french: "Notre maison est grande", english: "Our house is big" }
  ],
  "yenu": [
    { original: "Dada yenu ameketi", french: "Votre sœur est assise", english: "Your (all) sister is sitting" },
    { original: "Mtoto wenu ni mzuri", french: "Votre enfant est en bonne santé", english: "Your (all) child is doing well" },
    { original: "Kazi yenu ni haraka", french: "Votre travail est rapide", english: "Your (all) work is fast" }
  ],
  "yao": [
    { original: "Watoto wao wanasoma", french: "Leurs enfants étudient", english: "Their children are studying" },
    { original: "Nyumba yao ni kubwa", french: "Leur maison est grande", english: "Their house is big" },
    { original: "Kazi yao ni nzuri", french: "Leur travail est bon", english: "Their work is good" }
  ],

  // Pronoms compléments
  "ni": [
    { original: "Ananipenda", french: "Il/Elle m'aime", english: "He/She loves me" },
    { original: "Wananiona", french: "Ils/Elles me voient", english: "They see me" },
    { original: "Unaniaidia", french: "Tu m'aides", english: "You help me" }
  ],
  "ku": [
    { original: "Ninakuzungumzia", french: "Je te parle", english: "I am talking to you" },
    { original: "Anakupenda", french: "Il/Elle t'aime", english: "He/She loves you" },
    { original: "Tunakuona", french: "Nous te voyons", english: "We see you" }
  ],
  "m": [
    { original: "Mnamuona", french: "Vous le/la voyez", english: "You (all) see him/her" },
    { original: "Ninamupenda", french: "Je l'aime", english: "I love him/her" },
    { original: "Tunamuaidia", french: "Nous l'aidons", english: "We help him/her" }
  ],

  // Pronoms emphatiques
  "mimi ni": [
    { original: "Mimi ni mwenye kwenda", french: "Moi, je vais", english: "As for me, I am going" },
    { original: "Mimi ni mwenye kusoma", french: "Moi, j'étudie", english: "As for me, I am studying" },
    { original: "Mimi ni mwenye kufanya kazi", french: "Moi, je travaille", english: "As for me, I am working" }
  ],
  "wewe ni": [
    { original: "Wewe ni mwenye kusoma", french: "Toi, tu étudies", english: "As for you, you are studying" },
    { original: "Wewe ni mwenye kula", french: "Toi, tu manges", english: "As for you, you are eating" },
    { original: "Wewe ni mwenye kwenda nyumbani", french: "Toi, tu vas à la maison", english: "As for you, you are going home" }
  ],
  "yeye ni": [
    { original: "Yeye ni mwenye kuwa na", french: "Lui/Elle, il/elle a", english: "As for him/her, he/she has" },
    { original: "Yeye ni mwenye kufanya kazi", french: "Lui/Elle, il/elle travaille", english: "As for him/her, he/she is working" },
    { original: "Yeye ni mwenye kusoma", french: "Lui/Elle, il/elle étudie", english: "As for him/her, he/she is studying" }
  ],

  // Temps verbaux
  "ata kwenda": [
    { original: "Ata kwenda nyumbani kesho", french: "Il/Elle ira à la maison demain", english: "He/She will go home tomorrow" },
    { original: "Ata kwenda shuleni", french: "Il/Elle ira à l'école", english: "He/She will go to school" },
    { original: "Ata kwenda sokoni", french: "Il/Elle ira au marché", english: "He/She will go to the market" }
  ],
  "ana ona": [
    { original: "Ana ona mtu", french: "Il/Elle voit quelqu'un", english: "He/She sees someone" },
    { original: "Ana ona nyumba", french: "Il/Elle voit la maison", english: "He/She sees the house" },
    { original: "Ana ona mtoto", french: "Il/Elle voit l'enfant", english: "He/She sees the child" }
  ],
  "ana kaa": [
    { original: "Ana kaa nyumbani", french: "Il/Elle est assis(e) à la maison", english: "He/She is sitting at home" },
    { original: "Ana kaa ndani ya nyumba", french: "Il/Elle est assis(e) dans la maison", english: "He/She is sitting inside the house" },
    { original: "Ana kaa karibu na meza", french: "Il/Elle est assis(e) près de la table", english: "He/She is sitting near the table" }
  ],
  "ali kwenda": [
    { original: "Ali kwenda sokoni", french: "Il/Elle est allé(e) au marché", english: "He/She went to the market" },
    { original: "Ali kwenda nyumbani", french: "Il/Elle est allé(e) à la maison", english: "He/She went home" },
    { original: "Ali kwenda shuleni", french: "Il/Elle est allé(e) à l'école", english: "He/She went to school" }
  ],
  "hata kwenda": [
    { original: "Hata kwenda nyumbani kesho", french: "Il/Elle n'ira pas à la maison demain", english: "He/She will not go home tomorrow" },
    { original: "Hata kwenda sokoni", french: "Il/Elle n'ira pas au marché", english: "He/She will not go to the market" },
    { original: "Hata kwenda shuleni", french: "Il/Elle n'ira pas à l'école", english: "He/She will not go to school" }
  ],

  // Prépositions
  "katika": [
    { original: "Nina kaa katika nyumba", french: "Je suis assis dans la maison", english: "I am sitting in the house" },
    { original: "Ana kwenda katika soko", french: "Il/Elle va au marché", english: "He/She is going to the market" },
    { original: "Mtoto yu katika shule", french: "L'enfant est à l'école", english: "The child is at school" }
  ],
  "karibu na": [
    { original: "Ana karibu nami", french: "Il/Elle est à côté de moi", english: "He/She is next to me" },
    { original: "Mtoto yu karibu na meza", french: "L'enfant est près de la table", english: "The child is near the table" },
    { original: "Nina karibu na shule", french: "Je suis près de l'école", english: "I am near the school" }
  ],
  "chini ya": [
    { original: "Ufunguo uko chini ya meza", french: "La clé est sous la table", english: "The key is under the table" },
    { original: "Kitabu kiko chini ya kitanda", french: "Le livre est sous le lit", english: "The book is under the bed" },
    { original: "Mtoto yu chini ya mti", french: "L'enfant est sous l'arbre", english: "The child is under the tree" }
  ],
  "juu ya": [
    { original: "Ameweka juu ya meza", french: "Il/Elle a posé cela sur la table", english: "He/She placed it on the table" },
    { original: "Kitabu kiko juu ya meza", french: "Le livre est sur la table", english: "The book is on the table" },
    { original: "Mtoto yu juu ya kitanda", french: "L'enfant est sur le lit", english: "The child is on the bed" }
  ],

  // Adjectifs
  "mzuri": [
    { original: "Mke wake mzuri", french: "Sa femme est belle", english: "His wife is beautiful" },
    { original: "Mtoto mzuri anasoma", french: "Le bel enfant étudie", english: "The good child is studying" },
    { original: "Nyumba nzuri ni kubwa", french: "La belle maison est grande", english: "The beautiful house is big" }
  ],
  "mzima": [
    { original: "Mwili wake mzima", french: "Son corps est en bonne santé", english: "His/Her body is healthy" },
    { original: "Mtoto mzima anasoma", french: "L'enfant sain étudie", english: "The healthy child is studying" },
    { original: "Mwanamke mzima anafanya kazi", french: "La femme en bonne santé travaille", english: "The healthy woman is working" }
  ],
  "mkubwa": [
    { original: "Nyumba yangu kubwa", french: "Ma maison est grande", english: "My house is big" },
    { original: "Mtu mkubwa anaenda", french: "Le grand homme s'en va", english: "The big man is leaving" },
    { original: "Mti mkubwa uko nyuma ya nyumba", french: "Le grand arbre est derrière la maison", english: "The big tree is behind the house" }
  ],
  "mdogo": [
    { original: "Mtoto wake mdogo", french: "Son enfant est petit", english: "His/Her child is small" },
    { original: "Nyumba ndogo ni nzuri", french: "La petite maison est belle", english: "The small house is nice" },
    { original: "Mwanamke mdogo anafanya kazi", french: "La petite femme travaille", english: "The young woman is working" }
  ],
  "mzee": [
    { original: "Baba yake mzee", french: "Son père est vieux", english: "His/Her father is old" },
    { original: "Mwanamke mzee ameketi", french: "La vieille femme est assise", english: "The old woman is sitting" },
    { original: "Mzee anafanya kazi", french: "Le vieil homme travaille", english: "The old man is working" }
  ],
  "nzuri": [
    { original: "Elimu yake nzuri", french: "Son éducation est bonne", english: "His/Her education is good" },
    { original: "Mtoto mzuri anasoma", french: "Le bon enfant étudie", english: "The good child is studying" },
    { original: "Kazi nzuri ni muhimu", french: "Le bon travail est utile", english: "Good work is important" }
  ],
  "mbaya": [
    { original: "Kazi yake mbaya", french: "Son travail est mauvais", english: "His/Her work is bad" },
    { original: "Mtu mbaya anaenda", french: "La mauvaise personne s'en va", english: "The bad person is leaving" },
    { original: "Elimu mbaya ni ngumu", french: "La mauvaise éducation est difficile", english: "Bad education is difficult" }
  ]
};

export default sentencesgap;
export {};
